//  * @package         src/components/Dashboard
//  * @author          Riddhi D Parekh
//  * @date            22nd October 2018
//  * @type            Question Panel in Center Questions Component File
//  * @description -   This file renders the html and functionality for displaying question panels as individual components in center questions part.
<template>
  <div v-if="surveyQid = dbQid['dbQueId'] ? dbQid['dbQueId'] : dbQid['in_question_master_id']">
    <div
      :data-className="className"
      :data-controlName="controlName"
      :class="[isSkipLogic === false ? 'panel panel-default':'panel panel-default center_data_lop', (qid - 1) < skipLogicEndQues ? 'skip-logic-content' : '']"
      :id="'que_'+ qid"
      :data-qid="qid"
      :data-id="cid"
      :data-que-id="surveyQid"
      :data-que-type-id="dbQTypeId"
      :skip-logic-end-ques="skipLogicEndQues"
    >
      <div class="panel-heading">
        <span :class="questionNoClass">{{isNaN(questionNo) ? questionNo.split(' ')[0] : questionNo}}</span>
        <h4 class="panel-title">
          <a
            v-if="all.in_survey_type == 1 && (dbQTypeId == 18 || dbQTypeId == 21 || dbQTypeId == 28 || dbQTypeId == 27)"
            href="#"
            @click.prevent
            data-toggle="tooltip"
            data-placement="top"
            title="Invalid question for online Form"
          >
            <i id="invaidIcon" class="fa fa-exclamation-triangle" aria-hidden="true" @click.prevent></i>
          </a>
          <a
            v-if="all.in_survey_type == 4 && (dbQTypeId === 1 || dbQTypeId === 3 || dbQTypeId === 6 || dbQTypeId === 7 || dbQTypeId === 9 || dbQTypeId === 10 || dbQTypeId === 14 || dbQTypeId === 18 || dbQTypeId === 21 || dbQTypeId === 22 || dbQTypeId === 28 || dbQTypeId === 27 )"
            href="#"
            @click.prevent
            data-toggle="tooltip"
            data-placement="top"
            title="Invalid question in kiosk mode."
          >
            <i id="invaidIcon"
            class="fa fa-exclamation-triangle"
            aria-hidden="true"
            @click.prevent></i>
          </a>
          <a
            v-if="(all.in_survey_type ==   2 || all.in_survey_type == 3) && dbQTypeId == 18 && photoQuestionCount > 50"
            href="#"
            @click.prevent
            data-toggle="tooltip"
            data-placement="top"
    	      title="Only 50 Photo Questions allowed"
          >
            <i id="invaidIcon" class="fa fa-exclamation-circle" style="font-size:20px" aria-hidden="true" @click.prevent></i>
          </a>
          <a
            v-else-if="all.in_survey_type == 4 && (kioskQueCounter > 1) && (dbQTypeId === 4 || dbQTypeId === 5 || dbQTypeId === 19 )"
            href="#"
            @click.prevent
            data-toggle="tooltip"
            data-placement="top"
            title="Only one question allowed in kiosk mode."
          >
            <i id="invaidIcon"  
            class="fa fa-exclamation-triangle"
            aria-hidden="true"
            @click.prevent></i>
          </a>
          <!-- <a v-else></a> -->
          <svg height="512pt" viewBox="0 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg" v-if="cid == vueQueControlConfig.CONTROL_TIME">
            <path d="m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm121.75 388.414062c-4.160156 4.160157-9.621094 6.253907-15.082031 6.253907-5.460938 0-10.925781-2.09375-15.082031-6.253907l-106.667969-106.664062c-4.011719-3.988281-6.25-9.410156-6.25-15.082031v-138.667969c0-11.796875 9.554687-21.332031 21.332031-21.332031s21.332031 9.535156 21.332031 21.332031v129.835938l100.417969 100.414062c8.339844 8.34375 8.339844 21.824219 0 30.164062zm0 0"/>
          </svg>
          <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="501.5px" height="520.5px" viewBox="0 -8.5 501.5 520.5" enable-background="new 0 -8.5 501.5 520.5" xml:space="preserve" v-else-if="cid == vueQueControlConfig.CONTROL_TERMS_AND_CONDITIONS">
            <path d="M370.961,229.68c0.852,0,1.699,0.012,2.551,0.027l0.219,0.004c4.777,0.086,9.516,0.395,14.207,0.906V56.41
              c0-33.309-27.102-60.41-60.41-60.41H65.414C32.102-4,5,23.102,5,56.41v347.473c0,33.313,27.102,60.414,60.41,60.414h175
              c-15.102-24.27-23.023-51.988-23.023-80.957C217.387,298.61,286.277,229.68,370.961,229.68z M221.656,94.637h89.523
              c8.285,0,15,6.715,15,15s-6.715,15-15,15h-89.523c-8.281,0-15-6.715-15-15S213.375,94.637,221.656,94.637z M221.656,154.641h89.523
              c8.285,0,15,6.715,15,15s-6.715,15-15,15h-89.523c-8.281,0-15-6.715-15-15S213.375,154.641,221.656,154.641z M171.281,365.656
              H81.758c-8.285,0-15-6.715-15-15c0-8.281,6.715-15,15-15h89.523c8.281,0,15,6.719,15,15
              C186.281,358.942,179.563,365.656,171.281,365.656z M171.281,304.649H81.758c-8.285,0-15-6.715-15-15s6.715-15,15-15h89.523
              c8.281,0,15,6.715,15,15S179.563,304.649,171.281,304.649z M171.281,244.645H81.758c-8.285,0-15-6.715-15-15s6.715-15,15-15h89.523
              c8.281,0,15,6.715,15,15S179.563,244.645,171.281,244.645z M171.281,184.641H81.758c-8.285,0-15-6.715-15-15s6.715-15,15-15h89.523
              c8.281,0,15,6.715,15,15S179.563,184.641,171.281,184.641z M171.281,124.637H81.758c-8.285,0-15-6.715-15-15s6.715-15,15-15h89.523
              c8.281,0,15,6.715,15,15S179.563,124.637,171.281,124.637z M206.656,229.645c0-8.285,6.719-15,15-15h43.117c8.285,0,15,6.715,15,15
              s-6.715,15-15,15h-43.117C213.375,244.645,206.656,237.93,206.656,229.645z"/>
            <path d="M459.785,295.942c-23.023-23.43-53.773-36.656-86.582-37.234l-0.215-0.004c-0.676-0.012-1.352-0.023-2.027-0.023
              c-68.691,0-124.574,55.922-124.574,124.66c0,27.301,8.664,53.227,25.051,74.98c23.785,31.574,60.059,49.68,99.523,49.68
              c68.691,0,124.574-55.922,124.574-124.66C495.535,350.434,482.84,319.395,459.785,295.942z M424.188,363.074l-47.57,59.301
              c-2.957,3.684-7.309,5.617-11.711,5.617c-3.059,0-6.137-0.934-8.793-2.855l-35.48-25.707c-6.707-4.859-8.207-14.238-3.344-20.949
              c4.859-6.707,14.238-8.207,20.945-3.344l23.918,17.328l38.637-48.164c5.184-6.461,14.621-7.496,21.086-2.313
              C428.336,347.172,429.371,356.614,424.188,363.074z"/>
          </svg>
          <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="26.688px" height="26.563px" viewBox="0 -0.563 26.688 26.563" enable-background="new 0 -0.563 26.688 26.563" xml:space="preserve" v-else-if="cid == vueQueControlConfig.CONTROL_SIGNATURE">
            <g>
              <g>
                <path d="M20.127,4.158c0-0.61-0.237-1.184-0.669-1.616l-2.154-2.154c-0.425-0.425-1.029-0.669-1.63-0.669h-0.131v4.57h4.584V4.158
                  L20.127,4.158z"/>
              </g>
            </g>
            <g>
              <g>
                <path d="M14.258,15.438c0.146-0.443,0.4-0.855,0.732-1.189l5.158-5.136V5.813h-5.354c-0.42,0-0.736-0.341-0.736-0.762v-5.332
                  H2.633c-1.26,0-2.285,1.025-2.285,2.285v21.43c0,1.26,1.025,2.285,2.285,2.285h15.209c1.261,0,2.307-1.025,2.307-2.285v-5.686
                  l-0.838,0.817c-0.339,0.336-0.736,0.581-1.184,0.73l-2.422,0.809l-0.369,0.021c-0.61,0-1.188-0.297-1.546-0.795
                  c-0.355-0.494-0.452-1.135-0.259-1.715L14.258,15.438z M4.157,13.43h7.592c0.421,0,0.762,0.341,0.762,0.762
                  s-0.34,0.762-0.762,0.762H4.157c-0.421,0-0.762-0.341-0.762-0.762S3.736,13.43,4.157,13.43z M3.395,11.145
                  c0-0.421,0.341-0.762,0.762-0.762h7.592c0.421,0,0.762,0.341,0.762,0.762s-0.34,0.762-0.762,0.762H4.157
                  C3.736,11.906,3.395,11.565,3.395,11.145z M3.395,17.238c0-0.421,0.341-0.762,0.762-0.762h7.592c0.421,0,0.762,0.341,0.762,0.762
                  S12.17,18,11.749,18H4.157C3.736,18,3.395,17.659,3.395,17.238z M14.795,21.047c0.422,0,0.762,0.341,0.762,0.762
                  s-0.34,0.762-0.762,0.762h-4.57c-0.421,0-0.762-0.341-0.762-0.762s0.341-0.762,0.762-0.762H14.795z M4.157,8.859
                  c-0.421,0-0.762-0.341-0.762-0.762s0.341-0.762,0.762-0.762h10.639c0.422,0,0.762,0.341,0.762,0.762s-0.34,0.762-0.762,0.762
                  H4.157z"/>
              </g>
            </g>
            <g>
              <g>
                <path d="M15.639,16.111L14.976,18.1c-0.099,0.298,0.185,0.581,0.481,0.481l1.988-0.663L15.639,16.111z"/>
              </g>
            </g>
            <g>
              <g>
                <path d="M21.555,9.84l-5.017,5.017l2.164,2.163c1.134-1.134,3.339-3.34,5.017-5.017L21.555,9.84z"/>
              </g>
            </g>
            <g>
              <g>
                <path d="M25.9,7.655c-0.268-0.27-0.662-0.423-1.08-0.423s-0.813,0.154-1.082,0.424l-1.107,1.107l2.164,2.163
                  c0.605-0.606,1.025-1.025,1.107-1.107C26.496,9.223,26.496,8.252,25.9,7.655z"/>
              </g>
            </g>
            <g>
              <g>
                <g>
                  <path d="M25.902,9.819L25.902,9.819c0.002-0.002,0.002-0.003,0.004-0.004C25.904,9.816,25.904,9.817,25.902,9.819z"/>
                  <path d="M25.906,9.814c0.002-0.002,0.006-0.005,0.006-0.007C25.912,9.809,25.908,9.812,25.906,9.814z"/>
                  <path d="M25.912,9.808C25.918,9.803,25.918,9.803,25.912,9.808L25.912,9.808z"/>
                </g>
              </g>
            </g>
          </svg>
          <i :class="className" aria-hidden="true" v-else></i>
          <a data-toggle="collapse" data-parent="#accordion" href="#" class="collapse-new">
            {{questionName}}
            <i
              v-if="isSkipLogic === false"
              id="expandCollapse"
              :class="collapsed ? 'accordion-toggle collapsed' : 'accordion-toggle'"
              v-on:click.prevent="collapsed = !collapsed"
              aria-hidden="true"
            ></i>
          </a>
          <a
            v-if="isInSkipLogic === true && isSkipLogic === false"
            class="skip-logic-icon"
            href="#"
            @click.prevent
            data-toggle="tooltip"
            data-placement="top"
            title="Skip Logic Question"
          >
            <i id="skipIcon" class="icomoon-shuffle-option" aria-hidden="true"></i>
          </a>
          <ul class="nav question_option">
            <li
              v-if="all.in_audit && (dbQTypeId == 3 || dbQTypeId == 4 || dbQTypeId == 5 || dbQTypeId == 11 || dbQTypeId == 12 || dbQTypeId == 13 || dbQTypeId == 19 || dbQTypeId == 20) && isSkipLogic === false"
            >
              <a
                href="#"
                @click.prevent
                data-toggle="tooltip"
                data-placement="top"
                :title="dbQid['in_audit'] === 1 ? 'Score Question': (quesAuditFlags[surveyQid] && quesAuditFlags[surveyQid] == true) ? 'Please verify your score' : 'No score available'"
              >
                <i
                  id="scoreIcon"
                  :class="dbQid['in_audit'] === 1 ? 'modalActive fa fa-tachometer': (quesAuditFlags[surveyQid] && quesAuditFlags[surveyQid] == true) ? 'modalOrange fa fa-tachometer' : 'fa fa-tachometer'"
                  aria-hidden="true"
                  ref="scoreIcon"
                  v-tooltip="{
                  content: 'Question with allow more than one answers cannot have audit feature.',
                  trigger: 'manual',
                }"
                  @mouseleave="hideScore"
                  @click.prevent
                ></i>
              </a>
            </li>
            <li v-if="isSkipLogic === false">
              <a
                href="#"
                data-toggle="tooltip"
                data-placement="top"
                :title="(dbQTypeId == 17 || dbQTypeId == 2) ? '' : 'Required Question'"
              >
                <i
                  id="requiredIcon"
                  :class="selected == 1 ? 'reqSelected fa fa-asterisk' : 'fa fa-asterisk'"
                  :data-isrequired="(selected == 1) ? 0 : 1"
                  aria-hidden="true"
                  v-tooltip="{content: 'Required option is not available for this question.', show: isOpen, trigger: 'manual'}"
                  @mouseover="isTooltipRequired(dbQTypeId)"
                  @mouseleave="removeTooltip"
                ></i>
              </a>
            </li>
            <li v-if="isSkipLogic === false">
              <a
                href="#"
                @click.prevent
                data-toggle="tooltip"
                data-placement="top"
                title="Delete Question"
                class="deleteiconqus"
              >
                <i id="deleteIcon" class="fa fa-trash-o" aria-hidden="true"></i>
              </a>
            </li>
            <li v-if="isSkipLogic === false && all.in_survey_type !== 4">
              <a
                href="#"
                @click.prevent
                data-toggle="tooltip"
                data-placement="top"
                title="Copy Question"
                class="copyqusopt"
              >
                <i id="copyIcon" class="fa fa-clone" aria-hidden="true"></i>
              </a>
            </li>
            <li class="draganddropopt" v-if="isSkipLogic === false">
              <a
                href="#"
                @click.prevent
                data-toggle="tooltip"
                data-placement="top"
                title="Drag and Drop Question"
              >
                <i id="dragIcon" class="fa fa-arrows" aria-hidden="true"></i>
              </a>
            </li>
            <li v-if="isSkipLogic === true && !isNaN(questionNo)">
              <a
                href="#"
                @click.prevent
                data-toggle="tooltip"
                data-placement="top"
                title="Add skip logic"
              >
                <i id="addLogicIcon" class="fa fa-plus-circle" aria-hidden="true"></i>
              </a>
            </li>
          </ul>
        </h4>
      </div>
      <div v-if="!collapsed" class="panel-collapse collapse in show">
        <expanddisplay
          v-if="isSkipLogic === false"
          :qid="surveyQid"
          :ansInSkipLogic="ansInSkipLogic"
        ></expanddisplay>
      </div>
    </div>
    <div
      class="data_add_reco"
      v-if="getSkipLogicDetails[surveyQid] && getSkipLogicDetails[surveyQid].length > 0 && isSkipLogic === true"
    >
      <skip-rule
        v-for="(skiprule,index) in getSkipLogicDetails[surveyQid]"
        :dbQid="surveyQid"
        :key="index"
        :ruleNo="index"
        :questionNum="isNaN(questionNo) ? questionNo.split(' ')[0] : questionNo"
      ></skip-rule>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import expanddisplay from "./expanddisplay";
import skipRule from "./skipRule";
import { EventBus } from "../../main";
var { queControlConfig } = require("../../../config/config.js");
export default {
  name: "emptyquestion",
  components: {
    expanddisplay,
    skipRule
  },
  props: [
    "questionName",
    "className",
    "controlName",
    "cid",
    "qid",
    "dbQid",
    "isRequired",
    "dbQTypeId",
    "questionNo",
    "questionNoClass",
    "isInSkipLogic",
    "ansInSkipLogic",
    "skipLogicEndQues",
    "isAuditScoreAvailable",
  ],
  data() {
    return {
      collapsed: true,
      imgArray: [],
      selected: 0,
      isOpen: false,
      vueQueControlConfig: queControlConfig,
      surveyQid: 0,
      quesAuditFlags: {},
    };
  },
  beforeDestroy() {
    EventBus.$off("emitGetQuestionAllData");
  },
  mounted() {
    EventBus.$on("emitGetQuestionAllData", () => {
      this.updateAuditScoreColor();
    });
    this.selected = this.isRequired;
  },
  computed: {
    ...mapGetters("LeftSidebarCreate", ["all","photoQuestionCount", "kioskQueCounter"]),
    ...mapGetters("editquestionEdit", {
      questUpdated: "questionUpdated",
      isSkipLogic: "isSkipLogic",
      getQuestionAll: "getQuestionAll",
      getSkipLogicDetails: "getSkipLogicDetails"
    })
  },
  watch: {
    isRequired: function(val) {
      this.selected = val;
    },
    getQuestionAll: function(val) {
      this.updateAuditScoreColor();
    }
  },
  methods: {
    isTooltipRequired(dbQTypeId) {
      if (dbQTypeId == 17 || dbQTypeId == 2) {
        this.isOpen = true;
      } else {
        this.isOpen = false;
      }
    },
    removeTooltip() {
      this.isOpen = false;
    },
    hideScore() {
      this.$refs.scoreIcon._tooltip.hide();
    },
    updateAuditScoreColor() {
      // need to initialize variable for default color of audit button i.e. grey, blue and orange
      // Audit button reset color after change in question in Draft survey mode
      var quesDetails = this.isAuditScoreAvailable;
      // console.log(quesDetails)
      var temp = {};
      for (var key in quesDetails) {
        // console.log(key);
        var hasKeys = false;

        // othere question except RATING & List
        if(quesDetails[key].score_data) {
          var scoreData = quesDetails[key].score_data;
          for (var scorekey in scoreData) {
            if(scoreData[scorekey].st_answer_score != '' && scoreData[scorekey].st_answer_score != 'NA') {
              hasKeys = true;
              break; // break when found
            }
          }
        }

        // SATISFACTION RATING Question
        if(quesDetails[key]['qval_39']) {
          var scoreData = quesDetails[key]['qval_39']['st_answer_score'];
          if(scoreData && scoreData != '' && scoreData != 'NA') {
            hasKeys = true;
          }
        }

        // STAR RATING Question
        if(quesDetails[key]['qval_38']) {
          var scoreData = quesDetails[key]['qval_38']['st_answer_score'];
          if(scoreData && scoreData != '' && scoreData != 'NA') {
            hasKeys = true;
          }
        }

        // List Question
        if(quesDetails[key]['qval_6']) {
          var scoreData = quesDetails[key]['qval_6']['st_answer_score'];
          if(scoreData && scoreData != '' && scoreData != 'NA') {
            hasKeys = true;
          }
        }

        if(!temp[key])
          temp[key] = hasKeys;
      }

      // Assign default values in variable coming from centerquestion.vue file
      this.quesAuditFlags = Object.assign({}, this.quesAuditFlags, temp);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/emptyquestion.vue